module.exports = __webpack_public_path__ + "img/dsci0095.709db8ed.jpg";